import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-alt px-4 py-20 sm:py-24" data-id="element-45" data-mp="1nv1h60io1ju4">
      <Reveal className="mx-auto max-w-3xl" data-id="element-46" data-mp="2bk41xh8ljssu">
        <SectionHeading eyebrow="Dudas frecuentes" title="Preguntas Frecuentes" data-id="element-47" data-mp="2bmgok7paurc8" />
        <div className="mt-12 divide-y divide-brand-line overflow-hidden rounded-3xl border border-brand-line bg-brand-cream" data-id="element-48" data-mp="2flfotf035zxc">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} data-id="element-49" data-mp="2uigap1vlj0nw" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-sand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-terra sm:px-8" data-id="element-50" data-mp="2uhdj0rqg8u6x">
                  <span className="font-display text-base font-semibold text-brand-navy sm:text-lg" data-id="element-51" data-mp="20n18n04he6lb">
                    {faq.question}
                  </span>
                  {open ? <MinusIcon className="h-4 w-4 shrink-0 text-brand-terra" aria-hidden="true" data-id="element-52" data-mp="2agruryd4y4xu" /> : <PlusIcon className="h-4 w-4 shrink-0 text-brand-terra" aria-hidden="true" data-id="element-53" data-mp="2jfvhdcbih2h3" />}
                </button>
                <AnimatePresence initial={false} data-id="element-54" data-mp="p35i0f2dj12b">
                  {open && <motion.div id={panelId} role="region" className="overflow-hidden" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-55" data-mp="2p4vkzh175zm0">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-brand-gray sm:px-8 sm:text-[15px]" data-id="element-56" data-mp="380lr9gg5xi5p">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}